<template>
    <!-- 预约演示 -->
    <section class="home-company-icon">
        <div class="home-company-icon-title">
            <p>立即使用“全线上发薪报税平台”, 提升工作</p>
            <p>请填写真实信息，我们将有专属客服在1-2个工作日内联系您。中智薪税公司不会将您的信息分享、售卖、或交换给任何第三方公司</p>
        </div>
        <div class="home-company-icon-content">
            <el-form :model="params" :rules="rules" ref="ruleForm">
                <el-form-item label="公司名称" prop="companyName">
                    <el-input v-model="params.companyName"></el-input>
                </el-form-item>
                <el-form-item label="姓名" prop="name">
                    <el-input v-model="params.name"></el-input>
                </el-form-item>
                <el-form-item label="手机号" prop="phone">
                    <el-input v-model="params.phone"></el-input>
                </el-form-item>
                <el-form-item class="content-submit">
                    <el-button type="primary" @click="onSubmit('ruleForm')">预约演示</el-button>
                </el-form-item>
            </el-form>
        </div>
    </section>
</template>

<script>
import { gwSaveReportInfo } from '@/api/user/login';

export default {

	data() {
		return {
            params: {
                companyName: '',
                name: '',
                phone: ''
            },
            rules: {
                companyName: [
                    { required: true, message: '请输入公司名称', trigger: 'blur' },
                ],
                name: [
                    { required: true, message: '请输入名称', trigger: 'blur' },
                ],
                phone: [
                    { required: true, message: '请输入手机号', trigger: 'blur' },
                    { pattern: /^1[3-9]\d{9}$/, message: '手机号格式错误' }
                ],
            }
        }
	},

	computed: {},

	created() {},

    methods: {
        onSubmit(formName) {
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    let params = {
                        companyName: this.params.companyName,
                        connectName: this.params.name,
                        connectPhone: this.params.phone
                    }
                    gwSaveReportInfo(params).then(res => {
                        if (res.data.flag) {
                            this.$message.success('预约成功！客服在1-2个工作日内联系您！');
                        } else {
                            this.$message.warning(res.data.msg);
                        }
                    })
                }
            });
        },



    }

}
</script>

<style lang="scss" scoped>
/** 优势特点 */
.home-company-icon {
    margin-top: 40px;
    padding: 85px 0;
    background: #F6F8FA;
    .home-company-icon-title {
        text-align: center;
        p:first-child {
            font-size: 40px;
            line-height: 56px;
            color: #363636;
        }
        p:last-child {
            margin: 0 auto;
            margin-top: 20px;
            width: 600px;
            font-size: 20px;
            color: #B5B5B5;
            line-height: 46px;
        }
    }

    .home-company-icon-content {
        margin-top: 50px;
        &::v-deep .el-form {
            width: 446px;
            margin: 0 auto;
            .el-form-item__label {
                font-size: 24px;
                font-weight: 500;
                color: #333333;
                line-height: 33px;
                margin-bottom: 10px;
            }
            .el-form-item {
                margin-bottom: 40px;
            }
            .el-input__inner {
                height: 60px;
                line-height: 60px;
                border-radius: 30px;
                border: 1px solid #949494;
                background: #F6F8FA;
            }
            .content-submit {
                margin-top: 60px;
                text-align: center;
                .el-button {
                    width: 172px;
                    height: 56px;
                    background: #004999;
                    border-radius: 0;
                    border: none;
                    font-size: 24px;
                }
            }
        }

    }
}

</style>
